module.exports = __webpack_public_path__ + "img/intro.ec22b7e7.png";